
import { defineComponent } from 'vue';
import SpmButton from '@/components/spm-primevue/SpmButton.vue';

export default defineComponent({
  name: 'SpmEmptyState',

  components: {
    SpmButton,
  },

  props: {
    icon: {
      type: String,
      required: false,
      default: 'fa-regular fa-folder-open',
    },

    title: {
      type: String,
      required: true,
    },

    description: {
      type: String,
      required: false,
      default: '',
    },

    buttonLabel: {
      type: String,
      required: true,
    },

    buttonIcon: {
      type: String,
      required: false,
      default: 'far fa-plus-circle',
    },
  },

  emits: ['action'],
});
